export default {
  data() {
    return {
      transactionTypes: [
        {
          text: 'واریز',
          value: 'd'
        },
        {
          text: 'برداشت',
          value: 'w'
        },

      ],
      factorItemTypes: [
        { text: 'خرید اشتراک', value: 'bp' },
        { text: 'خرید ماژول', value: 'be' },
        { text: 'تمدید اشتراک', value: 'ep' },
        { text: 'اضافه کردن کاربر', value: 'au' },
        { text: 'اضافه کردن کسب و کار', value: 'ac' },
        { text: 'سایر', value: 'o' },
      ],
      modules: []
    }
  },
  methods: {
    getModules() {
      this.request({
        url: this.endpoint("subscriptions/modules"),
        method: "get",
        success: (data) => {
          this.modules = data;
        },
      });
    }
  }
}